import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';
import Utils3D from '../../utils/utils3D.js';

export default class NodeMirror extends Node
{
	constructor(pParent)
	{
		super(pParent);
		
		this.addInput(PARAM_TYPE.GEOMETRY, 'geo', null);

		this.addInput(PARAM_TYPE.BOOLEAN, 'flip_x', false);
		this.addInput(PARAM_TYPE.BOOLEAN, 'flip_y', false);
		this.addInput(PARAM_TYPE.BOOLEAN, 'flip_z', false);

		this.addInput(PARAM_TYPE.BOOLEAN, 'mirror_x', false);
		this.addInput(PARAM_TYPE.BOOLEAN, 'mirror_y', false);
		this.addInput(PARAM_TYPE.BOOLEAN, 'mirror_z', false);

		this.addInput(PARAM_TYPE.BOOLEAN, 'make_new_copy', false);

		this.addOutput(PARAM_TYPE.GEOMETRY, 'geo');	
	}
	
	getType()
	{
		return 'mirror';
	}
	
	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{		
		let pGeoList = inputValues['geo'];
		if(!pGeoList)
			return null;

		let pFinalMeshes = [];
		let iCounter = 0;
		for(let pSrcMesh of pGeoList)
		{
			let pFinalMesh = pSrcMesh;
			if(inputValues['make_new_copy'])
			{
				pFinalMesh = Utils3D.cloneMesh(pSrcMesh, this.getGeneratedMeshName() + "_" + iCounter);
				this.onMeshCreated(pFinalMesh);
				iCounter++;
			}

			if(inputValues['flip_x'])
				pFinalMesh.scaling.x *= -1;
			if(inputValues['flip_y'])
				pFinalMesh.scaling.y *= -1;
			if(inputValues['flip_z'])
				pFinalMesh.scaling.z *= -1;

			if(inputValues['mirror_x'])
				pFinalMesh.position.x *= -1;
			if(inputValues['mirror_y'])
				pFinalMesh.position.y *= -1;
			if(inputValues['mirror_z'])
				pFinalMesh.position.z *= -1;

			pFinalMeshes.push(pFinalMesh);
		}

		return pFinalMeshes;
	}
}